import McmAnnouncement, { McmDisplayStatus } from "./McmAnnouncement";

export const getDisplayStatus = (message: McmAnnouncement): McmDisplayStatus => {
  if (message.display_status) return message.display_status;
  if (message.status === "draft") return "draft";
  if (message.status === "closed") return "closed";
  if (message.status === "published") {
    const now = new Date();
    if (message.scheduled_start_date && new Date(message.scheduled_start_date) > now) return "scheduled";
    if (message.scheduled_end_date && new Date(message.scheduled_end_date) < now) return "expired";
    return "live";
  }
  return "draft";
};

export const downloadMediaFile = async (url: string): Promise<void> => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch file: ${response.statusText}`);
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    const rawFilename = url.split("/").pop()?.split("?")[0] || "attachment";
    try {
      link.download = decodeURIComponent(rawFilename);
    } catch {
      link.download = rawFilename;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch {
    // eslint-disable-next-line no-alert
    window.alert("Failed to download attachment. Please try again.");
  }
};
